module.exports = __webpack_public_path__ + "media/career/02-benefit-coffee-86a5c1c4.svg";